import * as yup from "yup";

export const CREATE_CDE_INITIAL_VALUES = {
  name: "",
  description: "",
  drafter: "",
  approver: "",
  isSecure: false,
  secureCde: "",
};
export const CREATE_CDE_VALIDATION_SCHEMA = yup.object({
  name: yup.string().trim().required("Name is required"),
  drafter: yup.object().required("Drafter is required"),
  approver: yup.object().required("Approver is required"),
  isSecure: yup.boolean(),
  secureCde: yup.string().when("isSecure", {
    is: true,
    then: yup.string().required("Choose a value"),
  }),
});
